import React from "react";
import NFTItem from "@components/NFTItem";
import {
  CollectionItemDataFragment,
  CollectionNftDetails,
  MarketplaceCollectionItem,
  MarketplaceCollectionItemResponse,
  MarketplaceCollectionItemV2,
} from "@graphql-generated";
import Grid from "@mui/material/Grid";
import Image from "next/image";
import styles from "./CardContainer.module.css";
import PaceLoader from "../../../public/images/loading.gif";
import { Box, Typography } from "@mui/material";

type Maybe<T> = T | null;

interface CardContainerProps {
  data?: MarketplaceCollectionItem[] | Maybe<Maybe<MarketplaceCollectionItemV2>[]> | undefined;
  name?: string;
  openFilter?: boolean;
  isSlug?: boolean;
  isLoading?: boolean;
  artistName?: string;
}
const CardContainer = ({ data, name, openFilter, isSlug, isLoading, artistName }: CardContainerProps): JSX.Element => {
  return (
    <div
      style={{ marginTop: '45px' }}
      className={`${"container"} ${styles["cardcontainer"]}`}
      id={"cardContainer"}
    >
      {/* <h2 className={styles.subHeading}>Discover Our Latest NFTs</h2> */}
      { isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Image alt="loader" width={ 150 } height={ 150 } style={{ height: '150px', width: '150px' }} src={PaceLoader} layout="fixed" objectFit="contain" unoptimized />
        </Box>
      ) : (
        <>
          {((data ?? [])?.length > 0 && !isLoading) ? (
            <Grid container spacing={4}>
              {data?.map((item) => (
                <Grid item xs={12} sm={6} md={6} lg={openFilter ? 4 : 3} className="card_main">
                  <NFTItem
                    title={item?.name}
                    saleStart={"Sale starts in 2 days 10 hrs 15 min"}
                    item={item as unknown as CollectionItemDataFragment}
                    breadCrumbsName={name}
                    imgURL={ (item as MarketplaceCollectionItem)?.NFTDetails?.[0]?.metadata?.image ?? (item as MarketplaceCollectionItem)?.asset?.currentVersion?.cdnUrl ?? ''}
                    isSlug={ isSlug }
                    artistName={ artistName }
                  // price={item.details}
                  />
                </Grid>
              ))}
            </Grid>
          ) : !isLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#6C717A' }}>
              <Typography>No results to display</Typography>
            </Box>
          ) : (
            <></>
          )}
        </>
      ) }

    </div>
  );
};

export default CardContainer;
